import React, { useEffect, useState } from 'react';

import { CSSBlockPage } from '@core/constants';
import { getAircrafts } from '@core/services/networkService/_aircraft';
import { nscRequest } from '@helpers/app.helper';
import { Aircraft } from '@models/aircraft.model';

import AircraftTable from './AircraftTable';

interface Props {}

const Inventory: React.FC<Props> = ({}) => {
  const CSSBlock = 'inventory';
  const [aircraft, setAircraft] = useState<Aircraft[]>([]);

  useEffect(() => {
    nscRequest(getAircrafts()).then(o => {
      console.log(o);
      setAircraft(o);
    });
  }, []);

  return (
    <div className={`${CSSBlockPage} ${CSSBlock}`}>
      <div className={`${CSSBlockPage}__title`}>Aircraft Inventory</div>
      <AircraftTable aircraft={aircraft} />
    </div>
  );
};

export default Inventory;
